import { defineMessages } from 'react-intl';

export default defineMessages({
  genericIntegrationName: {
    id: 'items.venue-permissions.generic-integration-name',
    defaultMessage: 'your POS',
  },
});
